import React from 'react';
function Smartphone({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <rect
        width="10"
        height="16"
        x="7"
        y="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        rx="2"
      />
      <rect width="1" height="1" x="11.5" y="16" rx=".5" />
    </svg>
  );
}

export default Smartphone;
